import { useQuery } from "@tanstack/react-query"
import { Axios } from "../utils/Axios"


export const useOrders = () => {
    return useQuery({
        queryKey: ['orders'],
        queryFn: async () => {
            const res = await Axios.get('/order/all');
            return res.data
        }
    })
}